import { Component, OnInit } from '@angular/core';
import { Address } from 'src/app/data/models/address.model';
import { CacheCountryService } from '../../../services/cacheCountries.service';
import { ReferenceLibraryService } from '../../../services/referenceLibrary.service';
import { ReferenceLibrary } from '../../../data/models/referenceLibrary.model';
import { PhoneContact } from '../../../data/models/phone-contact.model';
import { EmailContact } from '../../../data/models/email-contact.model';
import { Company } from '../../../data/models/company.model';
import { CompanyService } from '../../../services/company.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { AppState } from 'src/app/data/models/app-state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'data-setup-info',
  templateUrl: './data-setup.component.html',
  styleUrls: ['./data-setup.component.scss']
})
export class DataSetupComponent implements OnInit {
  company = new Company({ 
    companyName: '',
    emailContacts: [],
    emailContact: new EmailContact(),
    altEmailContact: new EmailContact(),
    phoneContacts: [],
    phoneContact: new PhoneContact(),
    mobileContact: new PhoneContact(),
    address: [new Address()],
    
  });

  listCompany: any;
  listCountry: [];
  listStates: [];
  addressTypeList: ReferenceLibrary[];
  phoneTypeList: ReferenceLibrary[];
  emailTypeList: ReferenceLibrary[];
  firmDetails;

  companyId;
  constructor(private router: Router, private route: ActivatedRoute,
    private cacheCountryService: CacheCountryService,
    private referenceLibraryService: ReferenceLibraryService,
    private companyService: CompanyService,
    private store: Store<AppState>,
    private toastr: ToastrService,) 
    {
      this.listStates = [];
      this.listCountry = [];

      this.referenceLibraryService.getReferenceData('ADDR').subscribe((data: ReferenceLibrary[]) => {
        this.addressTypeList = data;
      });
      this.referenceLibraryService.getReferenceData('PHON').subscribe((response: ReferenceLibrary[]) => {
        this.phoneTypeList = response;
      });
      this.referenceLibraryService.getReferenceData('EMLTYP').subscribe((response: ReferenceLibrary[]) => {
        this.emailTypeList = response;
      });
  
     }

  ngOnInit() {
    // this.cacheCountryService.getCountry().subscribe();
    //   this.cacheCountryService.getCachedCountryList().subscribe(data => {
    //     if (data.listCountries.length > 0) {
    //         this.listCountry = data.listCountries;
    //     }
    // });

    // if (sessionStorage.getItem('clientId')) {
    //   this.companyService.getCompaniesById(parseInt(sessionStorage.getItem('clientId'))).subscribe(data => {
    //     this.companyId = data.id;
    //     this.firmDetails = data;
    //     this.mapEmployeeDetails();
    //   });
    // }
  }
}